import * as React from 'react';
import { ReactReduxContext } from 'react-redux';
import hoistNonReactStatics from 'hoist-non-react-statics';
import getInjectors from './reducerInjectors';
import { InjectReducerParams } from 'types';

/**
 * Dynamically injects a reducer
 *
 * @param {string} key A key of the reducer
 * @param {function} reducer A reducer that will be injected
 *
 */

export default function hocWithReducer<P>({ key, reducer }: InjectReducerParams) {
  function wrap(WrappedComponent: React.ComponentType<P>): React.ComponentType<P> {
    // dont wanna give access to HOC. Child only
    class ReducerInjector extends React.Component<P> {
      public static WrappedComponent = WrappedComponent;
      // react-redux 8 không còn publish store lên legacy context (this.context.store).
      // Lấy store từ ReactReduxContext (v8) thay cho contextTypes cũ.
      public static contextType = ReactReduxContext;
      public declare context: React.ContextType<typeof ReactReduxContext>;
      public static displayName = `withReducer(${
        WrappedComponent.displayName || WrappedComponent.name || 'Component'
      })`;

      // eslint-disable-next-line react/no-deprecated
      public componentWillMount() {
        const { injectReducer } = getInjectors((this.context as any).store);

        injectReducer(key, reducer);
      }

      public render() {
        return <WrappedComponent {...this.props} />;
      }
    }

    return hoistNonReactStatics(ReducerInjector, WrappedComponent) as any;
  }
  return wrap;
}
